module.exports = __webpack_public_path__ + "img/L_TC.8bcfa708.png";